import { onRequest, RequestMethod } from "../common/axios/axios";
import { getApiUrl } from "../common/axios/getApiUrl";
import { getServiceId } from "../common/service";
import { QNA } from "./types/QNA.types";

export class QnaRepository {
    static onGetQnaList = (params: QNA.GetQnaListParams) => {
        return onRequest({
            url: getApiUrl('qna-list'),
            method: RequestMethod.POST,
            params,
        });
    }

    static onGetQnaDetail = (qnaNo: number) => {
        const serviceId = getServiceId()
        return onRequest({
            url: `${getApiUrl('qna-detail')}/${qnaNo}?serviceId=${serviceId}`,
            method: RequestMethod.GET,
        });
    }

    static onPostQna = (params: QNA.PostQnaParams) => {
        return onRequest({
            url: getApiUrl('qna-send'),
            method: RequestMethod.POST,
            params,
        });
    }
}
